import { getFocusables } from '../lib-getFocusables';
import { keyToIndex } from '../lib-menuFocus';
import { polyfillCustomEvent } from '../lib-polyfills';
import { clamp } from '../lib-codash';
// function for finding last item in a menu
export function dropdownRecursiveFindingLastItem(element, menuMode, isMobile) {
    var isApplicationMenu = menuMode === 'application';
    var isFlyOutMenu = menuMode === 'flyOut';
    var strToSelectlastItem = ':scope > li:not([role="separator"]):last-child';
    var recursiveFindinglastItem = function (lastItem) {
        var _a;
        // if element does not have any items
        if (!lastItem) {
            return undefined;
        }
        // if the submenu is in the last element of the list
        var submenu = lastItem.querySelector('[data-dropdown-focus="dropdown-listbox"]');
        if (submenu) {
            var getSubmenuTarget = function () {
                if (isApplicationMenu && !isMobile) {
                    return lastItem;
                }
                return submenu.querySelector('[data-dropdown-focus="dropdown-listbox-btn"]');
            };
            var submenuTarget = getSubmenuTarget();
            if (submenuTarget.getAttribute('aria-expanded') === 'true') {
                return recursiveFindinglastItem(submenu);
            }
            return submenuTarget;
        }
        // if list item has as a child checkbox - list item doesn't have tabindex
        var checkboxAslastItem = lastItem.querySelector('[data-dropdown-focus="dropdown-list-checkbox"] [type="checkbox"]');
        if (checkboxAslastItem) {
            return checkboxAslastItem;
        }
        // if the nesting still exists
        var allListItems = (_a = lastItem.querySelector('[data-dropdown-focus="dropdown-list"]')) === null || _a === void 0 ? void 0 : _a.querySelectorAll(strToSelectlastItem);
        if (allListItems) {
            return recursiveFindinglastItem(allListItems[allListItems.length - 1]);
        }
        // if there is a nested dropdown-list (story23, story27), the parent list item always doesn't have a tabindex attr
        if (lastItem.getAttribute('tabindex') && isApplicationMenu) {
            return lastItem;
        }
        if (isFlyOutMenu) {
            return lastItem.querySelector('a') || lastItem.querySelector('[type="checkbox"]');
        }
    };
    return recursiveFindinglastItem(element === null || element === void 0 ? void 0 : element.querySelector(strToSelectlastItem));
}
// apply to move focus in a menu by arrows
export function dropdownMenuFocus(menu, focusablesSelector) {
    polyfillCustomEvent();
    menu === null || menu === void 0 ? void 0 : menu.addEventListener('arrow', arrow);
    return function () { return menu.removeEventListener('arrow', arrow); };
    function arrow(e) {
        e.stopPropagation();
        var items = getFocusables(menu, focusablesSelector);
        var target = e.target;
        var currentIndex = items.indexOf(target);
        var unboundIndex = keyToIndex(e.detail, currentIndex, items.length);
        var boundIndex = clamp(unboundIndex, 0, items.length - 1);
        if (currentIndex !== boundIndex) {
            items[boundIndex].focus();
        }
    }
}
export var dropdownMobileViewChangeEventName = 'cgDropdownMobileView';
export var dropdownMobileViewChangeEventCunsumersSelector = '[data-e2e="cg-dropdown-submenu"], [data-e2e="cg-dropdown-listbox"]';
export var dropdownMobileViewChangeEvent = function (isMobile) {
    return new CustomEvent(dropdownMobileViewChangeEventName, { cancelable: true, detail: {
            isMobile: isMobile
        } });
};
